import React from "react";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {Container} from "react-bootstrap";
import {mygaSession} from "../../../scripts/myga-session";
import {APP_SECTION} from "../../../scripts/constants";
import {saveApplication} from "../../../scripts/sync-manager";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {PageManager} from "../../../scripts/page-manager";
import Question from "../../../components/Questions/Question";

class GeneralFL extends React.Component {

  constructor(props) {
    super(props);

    // Load the component state from the current application
    this.state = {
      errorMessage: '',
      general: mygaSession.getCurrentAppGeneral()
    };

  }

  validate = () => {
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Finances_ErrorMissingInformation
      });
      return false;
    }

    return true;
  };

  saveApplication = async () => {
    // populate finance object from fields
    let general = this.state.general;

    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.general,general);

    await saveApplication(APP_SECTION.general)
  };

  handleChange = (field) => (e) => {
    let general = this.state.general;
    general[field] = e.target ? e.target.value : e;

    this.setState({
      general: general,
      errorMessage:'',
    });
  };

  render() {
    return (
      <AppContentWrapper
        onBackPressed={this.saveApplication}
        onNextPressed={this.saveApplication}
        validateOnNext={this.validate}
        updatePage={this.props.updatePage}
        errorMessage={this.state.errorMessage}>

        <form className={'needs-validation'}
              ref={(form) => {
                this.pageForm = form;
              }}>
          <Container className={'pt-5 pl-5'}>
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('assistedLivingFL')}
              data={this.state.general}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('terminalIllnessFL')}
              data={this.state.general}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('memoryDiseaseFL')}
              data={this.state.general}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('saleArrangementFL')}
              data={this.state.general}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('trustEstablishmentFL')}
              data={this.state.general}
              onChange={this.handleChange}
            />

          </Container>
        </form>

      </AppContentWrapper>
    )
  }
}

export default GeneralFL